/**
 * Firebase Web SDK config (public keys — safe in client bundles).
 * Set REACT_APP_FIREBASE_* and REACT_APP_FIREBASE_VAPID_KEY in `.env.development` / `.env.production`.
 */

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? '',
};

export function isFirebaseWebPushConfigured(): boolean {
  return Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.projectId &&
      firebaseConfig.messagingSenderId &&
      firebaseConfig.appId &&
      process.env.REACT_APP_FIREBASE_VAPID_KEY
  );
}

export function getFirebaseWebConfig() {
  return firebaseConfig;
}

export function getFirebaseWebVapidKey(): string {
  return process.env.REACT_APP_FIREBASE_VAPID_KEY ?? '';
}
